export default __webpack_public_path__ + "static/media/job.d16273a5.png";